import {
  Action, FormHandlers, ModalSize, Portal, useModal,
} from '@doveit/bricks';
import React from 'react';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import { Applicant, JobApplication } from '../../../providers/api/dtos';
import CreateJobApplicationWithApplicant from '../create-job-application-with-applicant/CreateJobApplicationWithApplicant';

type ChildFnProps = {
  createJobApplication: VoidFunction,
};

export interface CreateJobApplicationWithApplicantActionProps {
  children?: (props: ChildFnProps) => React.ReactNode,
  onSuccess?: (applicant: Applicant, jobApplication: JobApplication) => void,
}

const CreateJobApplicationWithApplicantAction: React.FC<CreateJobApplicationWithApplicantActionProps> = ({
  children,
  onSuccess,
}) => {
  const modal = useModal();
  const formRef = React.useRef<FormHandlers>(null) as React.MutableRefObject<FormHandlers>;

  const onInternalSuccess = React.useCallback((applicant: Applicant, jobApplication: JobApplication) => {
    modal.close();
    onSuccess?.(applicant, jobApplication);
  }, [modal, onSuccess]);

  const submitForm = React.useCallback(() => {
    formRef.current?.handleSubmit();
  }, []);

  return (
    <>
      {children
        ? children({
          createJobApplication: () => modal.open(),
        })
        : (
          <Action
            label="Aggiungi"
            aria-label="Aggiungi una nuova candidatura"
            size="S"
            onClick={() => modal.open()}
          />
        )}
      <Portal>
        <SimpleModal
          {...modal}
          title="Aggiungi candidatura"
          size={ModalSize.MEDIUM}
          aria-label="Modale per aggiungere una nuova candidatura"
          close={modal.close}
          footer={(
            <Action
              label="Aggiungi"
              color="primary"
              emphasis="high"
              aria-label="Pulsante per aggiungere una nuova candidatura"
              onClick={submitForm}
            />
          )}
        >
          <CreateJobApplicationWithApplicant
            formRef={formRef}
            onSuccess={onInternalSuccess}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};

export default CreateJobApplicationWithApplicantAction;
